import { SvgDownload } from "../svg/SvgDownload";
import { DocumentInterface } from "../../interfaces/documents/DocumentInterface";
import { JSX } from "react";
import { useStringTranslation } from "../../hooks/useStringTranslation";

interface Props {
    data: DocumentInterface;
}

export const DownloadItem = (props: Props): JSX.Element => {
    const { data } = props;
    const { t } = useStringTranslation();

    return (
        <a
            href={data.fileUrl}
            target="_blank"
            rel="noreferrer"
            className="c-download-item"
        >
            <div className="c-download-item__left">
                <span>{data.fileName}</span>
            </div>
            <span className="c-download-item__middle">{data.fileType}</span>
            <span className="c-download-item__right">
                <div>
                    <div className="c-download-item__download-icon">
                        <SvgDownload color={"#151112"} />
                    </div>
                    {t("download")}
                </div>
            </span>
        </a>
    );
};
